import { TermsAndConditions } from 'components/terms';
const TermsAndConditionsContainer = TermsAndConditions;
export { TermsAndConditionsContainer };
